// extracted by mini-css-extract-plugin
export default {"root":"Accordion_root__B9DhY","tab":"Accordion_tab__Xnp0Z","arrow":"Accordion_arrow__hEyZz","active":"Accordion_active__JT3I7"};